import React from "react";
import { ArrowDownToLine, ArrowUpFromLine, TriangleAlert } from "lucide-react";
import { TIPO, ESTADO } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { t } from "@/lib/i18n";

export function TipoTag({ tipo, variant = "soft", size = "md", className, ...rest }) {
  const tt = TIPO[tipo];
  if (!tt) return null;
  const Icon = tipo === "importacion" ? ArrowDownToLine : ArrowUpFromLine;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-[6px] font-display font-bold tracking-[.08em] whitespace-nowrap",
        size === "lg" ? "text-[14px] px-3 py-2 gap-2" : "text-[11.5px] px-2 py-[3px]",
        variant === "solid" ? tt.solid : tt.badge,
        className
      )}
      {...rest}
    >
      <Icon className={size === "lg" ? "h-5 w-5" : "h-3.5 w-3.5"} strokeWidth={2.4} />
      {tt.label}
    </span>
  );
}

export function PillDot({ color, children, className, strike, ...rest }) {
  return (
    <span
      className={cn("inline-flex items-center gap-1.5 rounded-full bg-surface-2 border border-line px-2.5 py-[3px] text-[12.5px] font-semibold text-ink-2 whitespace-nowrap", className)}
      {...rest}
    >
      <span className="h-[7px] w-[7px] rounded-full shrink-0" style={{ background: color }} />
      <span className={strike ? "line-through" : ""}>{children}</span>
    </span>
  );
}

export function EstadoPill({ estado, conProblema, className, ...rest }) {
  const e = ESTADO[estado];
  if (!e) return null;
  return (
    <span className="inline-flex items-center gap-1.5 flex-wrap">
      <PillDot color={e.color} strike={estado === "cancelada"} className={className} {...rest}>{e.label}</PillDot>
      {conProblema && (
        <span className="inline-flex items-center gap-1 text-[12.5px] font-semibold text-danger" data-testid="indicador-problema">
          <TriangleAlert className="h-3.5 w-3.5" />{t(" Problema")}</span>
      )}
    </span>
  );
}
